import React from 'react';
import { getUserType } from '../../utils/authStorage';
import usePriorityProfileReminder from '../../hooks/usePriorityProfileReminder';

function PriorityProfileReminderBanner() {
  const userType = getUserType();
  const { visible } = usePriorityProfileReminder();

  if (!['User', 'TeamLead'].includes(userType) || !visible) {
    return null;
  }

  return (
    <div className="hr-priority-reminder-banner" role="alert">
      <div className="hr-priority-reminder-content">
        <div className="hr-priority-reminder-title">Warning</div>
        <p className="hr-priority-reminder-text mb-0">
          You have priority requirements (P1-P5) that do not have profiles uploaded yet.
        </p>
      </div>
    </div>
  );
}

export default PriorityProfileReminderBanner;
